import { determineDeploymentEnvironment } from 'shared/helpers/determineEnvironment'
import { ON_SERVER } from 'shared/enums/environment'

export const determineHostname = () => {
  // If we dont know the domain we reuturn '' which will make it relative url
  if (ON_SERVER) {
    return determineDeploymentEnvironment().isLive ? 'https://eola.co' : ''
  }

  if (typeof window === 'undefined') {
    return ''
  }

  return `https://${window.location.host}`
}
